// @ts-strict-ignore
import Image from 'next/image';

import {
  Background,
  BlurbContainer,
  Container,
  ContentCenter,
  Header,
  ImageContainer,
  ImageText,
  ImageTitle,
  ImageWrapper,
  Images,
  TitleText
} from './Steps.styles';

const IMAGE_WIDTH = 56;
const IMAGE_HEIGHT = 56;

const imageLoader = ({ src }: { src: string }) => {
  const appUrl = process.env.CARVANA_APP_PUBLIC_URL!;
  const prefix = appUrl.includes('localhost') ? appUrl : `${appUrl}/next`;
  return `${prefix}${src}.svg`;
};

const Steps = () => (
  <Background>
    <ContentCenter>
      <Container>
        <Header>How It Works</Header>
        <TitleText>Trade in or sell your vehicle to Carvana in just a few easy steps.</TitleText>
        <Images>
          <ImageContainer>
            <ImageWrapper>
              <Image
                src="/images/IconMoneyHand"
                loader={imageLoader}
                alt="Get Your Offer"
                width={IMAGE_WIDTH}
                height={IMAGE_HEIGHT}
              />
            </ImageWrapper>
            <BlurbContainer>
              <ImageTitle>Get Your Offer</ImageTitle>
              <ImageText>
                Share a few vehicle details and we’ll extend a real offer in 2 minutes. No haggling.
                No hassles.
              </ImageText>
            </BlurbContainer>
          </ImageContainer>

          <ImageContainer>
            <ImageWrapper>
              <Image
                src="/images/IconTradeChiron"
                loader={imageLoader}
                alt="Trade in or Sell"
                width={IMAGE_WIDTH}
                height={IMAGE_HEIGHT}
              />
            </ImageWrapper>
            <BlurbContainer>
              <ImageTitle>Trade in or Sell</ImageTitle>
              <ImageText>Trade in your old vehicle for a new one, or sell it to Carvana.</ImageText>
            </BlurbContainer>
          </ImageContainer>

          <ImageContainer>
            <ImageWrapper>
              <Image
                src="/images/IconMoney"
                loader={imageLoader}
                alt="Get Paid"
                width={IMAGE_WIDTH}
                height={IMAGE_HEIGHT}
              />
            </ImageWrapper>
            <BlurbContainer>
              <ImageTitle>Get Paid</ImageTitle>
              <ImageText>
                We’ll do a quick, on-site review of your vehicle and pay you on the spot.
              </ImageText>
            </BlurbContainer>
          </ImageContainer>
        </Images>
      </Container>
    </ContentCenter>
  </Background>
);

export default Steps;
